"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlurDataURL = void 0;
const loader_1 = require("./loader");
function getBlurDataURL(src, width = 10, quality = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        const cdnUrl = (0, loader_1.uploadcareLoader)({
            src: src,
            width,
            quality
        });
        const response = yield fetch(cdnUrl);
        const contentType = response.headers.get('content-type');
        const arrayBuffer = yield response.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);
        const base64 = buffer.toString('base64');
        const dataURL = `data:${contentType};base64,${base64}`;
        return dataURL;
    });
}
exports.getBlurDataURL = getBlurDataURL;
